import { useState } from 'react';
import axiosInstance from 'interceptor/axiosInstance';
import { ApiRoutes } from 'routes/routeConstants/apiRoutes';
import { generatePath } from 'react-router-dom';
import Notification from 'shared/components/Notification';
import { NotificationTypes } from 'enums/NotificationEnums';
import { ApiKeysMessages } from 'enums/ApiKeysEnums';
import {
  ApiKeyListItem,
  ApiKeyCreatedData,
} from 'models/ApiKey/ApiKey.model';

const ApiKeysService = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [buttonLoading, setButtonLoading] = useState<boolean>(false);
  const [apiKeys, setApiKeys] = useState<ApiKeyListItem[]>([]);

  const fetchApiKeys = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(ApiRoutes.API_KEYS);
      setApiKeys(response.data?.data ?? []);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const refreshApiKeysQuiet = async () => {
    try {
      const response = await axiosInstance.get(ApiRoutes.API_KEYS);
      setApiKeys(response.data?.data ?? []);
    } catch (error) {
    }
  };

  const createApiKey = async (
    name: string
  ): Promise<ApiKeyCreatedData | undefined> => {
    try {
      setButtonLoading(true);
      const response = await axiosInstance.post(ApiRoutes.API_KEYS, { name });
      const createdKey: ApiKeyCreatedData = response.data?.data;
      Notification({
        message: ApiKeysMessages.KEY_CREATED,
        description: '',
        type: NotificationTypes.SUCCESS,
      });
      await fetchApiKeys();
      return createdKey;
    } catch (error) {
      return undefined;
    } finally {
      setButtonLoading(false);
    }
  };

  const deleteApiKey = async (id: string): Promise<boolean> => {
    try {
      setButtonLoading(true);
      const url = generatePath(ApiRoutes.API_KEY_SPECIFIC, { id });
      await axiosInstance.delete(url);
      setApiKeys(prev => prev.filter(k => k.id !== id));
      Notification({
        message: ApiKeysMessages.KEY_DELETED,
        description: '',
        type: NotificationTypes.SUCCESS,
      });
      void refreshApiKeysQuiet();
      return true;
    } catch (error) {
      return false;
    } finally {
      setButtonLoading(false);
    }
  };

  return {
    loading,
    buttonLoading,
    apiKeys,
    fetchApiKeys,
    createApiKey,
    deleteApiKey,
  };
};

export default ApiKeysService;
